import React from 'react'

import { Context } from './Context'

/**
 */
export const Provider = ({ value, ...props }) => (
  <Context.Provider value={{ value }} {...props} />
)
